import React from "react";
import { Content, ContentVariants, Tooltip, Label } from "@patternfly/react-core";
import { getMediaUrl } from "../../../utils/media";
import { shareResolveOptimistic } from "../../../utils/share";

export const DevSolutionsCell = ({ row, props, context, setSheets, branch }) => {
  const { raw } = row;
  const { api_url } = props.state;
  const isSuperuser = props.state.userProfile?.is_superuser;

  const handleDownload = (url) => {
    if (!url) return;
    getMediaUrl(url, "");
  };

  const handleShare = (event, solutionId, value) => {
    event.stopPropagation();
    if (!isSuperuser) return;

    shareResolveOptimistic(
      api_url,
      props.state.organization_symbol,
      branch,
      solutionId,
      value,
      setSheets
    );
  };

  const renderLink = ({
    label,
    tooltip,
    url,
    published,
    onClick,
    external,
    labelComponent,
    labelColor
  }) => {
    const isDisabled = !url || url === "None" || !published || !context.state.isAuthUser;

    const content = labelComponent ? (
      isDisabled ? (
        <Label
          textMaxWidth="16ch"
          style={{ marginRight: "2px", fontWeight: "bold" }}
          isCompact
          color="gray"
        >
          {label}
        </Label>
      ) : (
        <Content
          component={ContentVariants.a}
          href={external ? url : "#"}
          target={external ? "_blank" : undefined}
          onClick={onClick ? (e) => { e.preventDefault(); onClick(url); } : undefined}
        >
          <Label
            textMaxWidth="16ch"
            style={{ marginRight: "2px", fontWeight: "bold" }}
            isCompact
            color={labelColor || "blue"}
          >
            {label}
          </Label>
        </Content>
      )
    ) : isDisabled ? (
      <span style={{ marginLeft: "4px", color: "gray" }}>{label}</span>
    ) : (
      <Content
        component={ContentVariants.a}
        href={external ? url : "#"}
        target={external ? "_blank" : undefined}
        onClick={onClick ? (e) => { e.preventDefault(); onClick(url); } : undefined}
      >
        <span style={{ marginLeft: "4px" }}>{label}</span>
      </Content>
    );

    return <Tooltip content={<div>{tooltip}</div>}><span>{content}</span></Tooltip>;
  };


  // 🔹 isDisabled dla nowych rozwiązań ignoruje publikację
  const newSolutions = raw.solutions?.map(sol => {
    const url = sol.solution_url
      ? sol.solution_url
      : `${props.state.api_url}/ti/sheets/${raw.sheet_id}/solution/download/`;
    // Wystarczy to poniżej ale udostępnienie nie działa do sprawdzenia
    // const url = sol.url;
    const tooltip = sol.solution_type.join(", ");
    // const label = sol.solution_type.length ? sol.solution_type.join("-") : sol.label;
    const label = sol.label
      ? sol.label
      : sol.solution_type && sol.solution_type.length > 0
      ? sol.solution_type.join("-")
      : "solution";

    return renderLink({
        // label: `[${sol.label}]`,
        label: `[${label}]`,
        tooltip: tooltip,
        url: url,
        published: raw.solution_published && sol.published,
        onClick: url ? handleDownload : undefined,
        external: true
    });
  }) || [];

  return (
    <>
      {newSolutions.map((link, i) => <React.Fragment key={`newsol-${i}`}>{link}</React.Fragment>)}
    </>
  );
};